import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from '../../components/toasts';
import { Button, ErrorText, Field, Input, Modal } from '../../components/ui';
import { post } from '../../lib/api';

/**
 * Cancelar: encerra sem chamado, sem registro no Agidesk e sem mensagem de encerramento ao cliente.
 * Para mensagens que não pedem atendimento (ex.: "obrigado" depois de finalizado).
 */
export function CancelModal({ attendanceId, onClose, onCancelled }: { attendanceId: string; onClose: () => void; onCancelled: () => void }) {
  const qc = useQueryClient();
  const [note, setNote] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    setSaving(true);
    setError(null);
    try {
      await post(`/attendances/${attendanceId}/cancel`, { note: note.trim() || undefined });
      void qc.invalidateQueries({ queryKey: ['attendances'] });
      void qc.invalidateQueries({ queryKey: ['attendance', attendanceId] });
      toast('Atendimento cancelado', 'ok');
      onCancelled();
    } catch (err) {
      setError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      title="Cancelar atendimento"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Voltar</Button>
          <Button variant="danger" onClick={() => void confirm()} loading={saving}>
            Cancelar atendimento
          </Button>
        </>
      }
    >
      <p className="mb-3 text-sm">
        O atendimento é encerrado <b>sem chamado</b>: nada é registrado no Agidesk e o cliente <b>não</b> recebe a mensagem de encerramento. Use para mensagens que não pedem atendimento, como um
        &quot;obrigado&quot; depois de finalizado.
      </p>
      <Field label="Motivo" hint="(opcional)">
        <Input value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} placeholder="Ex.: Cliente só agradeceu" autoFocus />
      </Field>
      <ErrorText error={error} />
    </Modal>
  );
}
